import { PlayerEvent, ViewMode } from 'bitmovin-player';
import { logEvent } from './eventlogging';
const logEventHandlers = new Map();
export function bindPlayerEvents(npoPlayer, player) {
    if (player == undefined)
        return;
    const isLiveStream = npoPlayer.streamObject.stream.isLiveStream;
    let isNewSource = true;
    let data = {};
    const timeDifference = (time) => {
        if (time === undefined || time === null)
            return;
        const currentUnixTime = Date.now() / 1000;
        const timeOffset = (time - currentUnixTime).toFixed(3);
        const threeDecimalTime = time.toFixed(3);
        const currentTime = isLiveStream ? +timeOffset : +threeDecimalTime;
        data = { stream_position: currentTime };
    };
    const logEventHandler = (eventName) => {
        return (e) => {
            timeDifference(e.time);
            logEvent(npoPlayer, eventName, data);
        };
    };
    const seekHandler = (e) => {
        if (e.type === 'timeshift') {
            const timeDifferencePosition = -1 * (Date.now() / 1000 - e.position);
            const timeDifferenceTarget = -1 * (Date.now() / 1000 - e.target);
            data = {
                seek_from: Number.parseFloat(timeDifferencePosition.toFixed(3)),
                stream_position: Number.parseFloat(timeDifferenceTarget.toFixed(3))
            };
        }
        else if (e.type === 'seek') {
            data = {
                seek_from: e.position,
                stream_position: e.seekTarget
            };
        }
        logEvent(npoPlayer, 'seek', data);
    };
    const handleSourceLoaded = (e) => {
        timeDifference(e.time);
        isNewSource = true;
        if (isLiveStream) {
            logEvent(npoPlayer, 'stop', data);
        }
    };
    const handlePlay = (e) => {
        timeDifference(e.time);
        if (!isNewSource && e.issuer !== 'ui-seek') {
            logEvent(npoPlayer, 'resume', data);
        }
    };
    const pausedHandler = (e) => {
        timeDifference(e.time);
        if (e.issuer !== 'ui-seek') {
            logEvent(npoPlayer, 'pause', data);
        }
    };
    const handleTime = (e) => {
        timeDifference(e.time);
        if (isNewSource && !npoPlayer.adBreakActive) {
            logEvent(npoPlayer, 'start', data);
            isNewSource = false;
        }
        else {
            logEvent(npoPlayer, 'time', data);
        }
    };
    const handleViewModeChange = (e) => {
        const newViewMode = player.getViewMode();
        timeDifference(e.time);
        if (newViewMode === ViewMode.Fullscreen) {
            logEvent(npoPlayer, 'fullscreen', data);
        }
        else {
            logEvent(npoPlayer, 'windowed', data);
        }
    };
    const stopBeforeUnload = (e) => {
        timeDifference(e.time);
        logEvent(npoPlayer, 'stop', data);
    };
    for (const [key, value] of logEventHandlers) {
        player.off(key, value);
    }
    window.removeEventListener('beforeunload', logEventHandlers.get('stopBeforeUnload'));
    logEventHandlers.clear();
    const playerEvents = [
        { event: PlayerEvent.Ready, name: 'load_complete' },
        { event: PlayerEvent.Paused, handler: pausedHandler },
        { event: PlayerEvent.Play, handler: handlePlay },
        { event: PlayerEvent.SourceLoaded, handler: handleSourceLoaded },
        { event: PlayerEvent.StallStarted, name: 'buffering' },
        { event: PlayerEvent.StallEnded, name: 'buffering_complete' },
        { event: PlayerEvent.PlaybackFinished, name: 'complete' },
        { event: PlayerEvent.SourceUnloaded, name: 'stop' },
        { event: PlayerEvent.Seek, handler: seekHandler },
        { event: PlayerEvent.TimeShift, handler: seekHandler },
        { event: PlayerEvent.TimeChanged, handler: handleTime },
        { event: PlayerEvent.ViewModeChanged, handler: handleViewModeChange }
    ];
    for (const { event, name, handler } of playerEvents) {
        const effectiveName = name || 'unnamed_event';
        const eventHandler = handler || logEventHandler(effectiveName);
        logEventHandlers.set(event, eventHandler);
        player.on(event, eventHandler);
    }
    logEventHandlers.set('beforeunload', stopBeforeUnload);
    window.addEventListener('beforeunload', stopBeforeUnload);
}
